<template>
    <section id="ticket" class="bg-white-3">
        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-md-7">
                    <h2 class="font-family-alt sm-title-large title-extra-large-2 text-gray-dark-2 vw-bold">{{ title }}</h2>
                    <span class="bg-base-color margin-6-5 no-margin-bottom no-margin-rl separator-line-extra-thick-long"></span>
                    <!--<p class="font-family-alt margin-5-5 no-margin-bottom no-margin-rl sm-text-large text-extra-large text-gray-dark-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean in nunc sed tellus scelerisque mattis. Nunc blandit condimentum facilisis. Ut enim dolor, feugiat quis gravida vel, maximus sit amet tellus.</p>-->
                    <div class="testimonial margin-6 no-margin-bottom no-margin-rl">
                        <div class="bg-white border border-gray-light border-round padding-5 width-100">
                            <p class="no-margin text-gray-dark- text-large">
                                <slot name="statement"></slot>
                            </p>
                        </div>
                        <div class="col-md-6 testimonial-avatar position-relative" v-if="mainEmployeeName">
                            <img :src="mainEmployeeImage" alt="" style="border-radius:1000px;"/>
                            <div class="testimonial-avatar-label">
                                <div class="display-table height-100">
                                    <div class="display-table-cell vertical-align-middle">
                                        <span class="display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase">{{ mainEmployeeName }}</span>
                                        <span class="margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2">{{ mainEmployeeTitle }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 testimonial-avatar position-relative" v-if="secondaryEmployeeName">
                            <img :src="secondaryEmployeeImage" alt="" style="border-radius:1000px;"/>
                            <div class="testimonial-avatar-label">
                                <div class="display-table height-100">
                                    <div class="display-table-cell vertical-align-middle">
                                        <span class="display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase">{{ secondaryEmployeeName }}</span>
                                        <span class="margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2">{{ secondaryEmployeeTitle }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 testimonial-avatar position-relative" v-if="thirdEmployeeName">
                            <img :src="thirdEmployeeImage" alt="" style="border-radius:1000px;"/>
                            <div class="testimonial-avatar-label">
                                <div class="display-table height-100">
                                    <div class="display-table-cell vertical-align-middle">
                                        <span class="display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase">{{ thirdEmployeeName }}</span>
                                        <span class="margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2">{{ thirdEmployeeTitle }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 testimonial-avatar position-relative" v-if="fourthEmployeeName">
                            <img :src="fourthEmployeeImage" alt="" style="border-radius:1000px;"/>
                            <div class="testimonial-avatar-label">
                                <div class="display-table height-100">
                                    <div class="display-table-cell vertical-align-middle">
                                        <span class="display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase">{{ fourthEmployeeName }}</span>
                                        <span class="margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2">{{ fourthEmployeeTitle }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 testimonial-avatar position-relative" v-if="fifthEmployeeName">
                            <img :src="fifthEmployeeImage" alt="" style="border-radius:1000px;"/>
                            <div class="testimonial-avatar-label">
                                <div class="display-table height-100">
                                    <div class="display-table-cell vertical-align-middle">
                                        <span class="display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase">{{ fifthEmployeeName }}</span>
                                        <span class="margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2">{{ fifthEmployeeTitle }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4 col-md-offset-1 xs-margin-8 xs-no-margin-bottom xs-no-margin-rl">
                    <div class="pricing bg-white border border-gray-light border-round box-shadow-yes ease position-relative">
                        <!--<span class="bg-base-color border-round display-block font-family-alt letter-spacing-1 margin-6 padding-tb-9px padding-rl-13px position-absolute position-top position-right text-extra-small text-uppercase text-white">Hot</span>-->
                        <div class="display-table height-100 no-padding-tb padding-13 width-100">
                            <div class="display-table-cell no-padding-rl padding-18 text-center vertical-align-middle">
                                <span class="display-block font-family-alt letter-spacing-1 text-gray-dark-2 text-large text-uppercase">PRIS FOR DELTAGELSE</span>
                                <span class="vw-bold display-block font-family-alt margin-11 no-letter-spacing no-margin-bottom no-margin-rl text-gray-dark-2 title-extra-large-4">
                                    {{ price }}
                                    <!--<span class="pricing-dollar position-relative title-large">kr.</span>-->
                                </span>
                                <span class="bg-gray-light-2 margin-10-5 no-margin-bottom no-margin-rl separator-line-full"></span>
                                <ul class="list-unstyled margin-11 no-margin-bottom no-margin-rl text-gray-dark2 text-large text-left">
                                    <slot name="benefits"></slot>
                                </ul>
                                <p class="margin-11 no-margin-bottom no-margin-rl text-gray-dark-2 text-medium">Tilmelding skal ske senest 10 dage før arrangementets start, da mad & drikke bestilles forinden.</p>
                            </div>
                        </div>
                        <!--<a href="#register" class="page-scroll btn btn-base-color btn-large display-block letter-spacing-2 text-small width-100 vw-bold">Tilmeld dig nu</a>-->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                require: true
            },
            price: {
                type: String,
                require: true
            },
            mainEmployeeName: {
                type: String,
                require: true
            },
            mainEmployeeImage: {
                type: String,
                require: true
            },
            mainEmployeeTitle: {
                type: String,
                require: true
            },
            secondaryEmployeeName: {
                type: String,
                require: false
            },
            secondaryEmployeeImage: {
                type: String,
                require: false
            },
            secondaryEmployeeTitle: {
                type: String,
                require: false
            },
            thirdEmployeeName: {
                type: String,
                require: false
            },
            thirdEmployeeImage: {
                type: String,
                require: false
            },
            thirdEmployeeTitle: {
                type: String,
                require: false
            },
            fourthEmployeeName: {
                type: String,
                require: false
            },
            fourthEmployeeImage: {
                type: String,
                require: false
            },
            fourthEmployeeTitle: {
                type: String,
                require: false
            },
            fifthEmployeeName: {
                type: String,
                require: false
            },
            fifthEmployeeImage: {
                type: String,
                require: false
            },
            fifthEmployeeTitle: {
                type: String,
                require: false
            }
        }
    }
</script>
<style scoped>
    .testimonial{
        max-width: 10000px !important;
    }
    @media screen and (max-width:768px){
        .padding-13{
            padding: 9% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// statement-and-price.vue?12614198